import { render, staticRenderFns } from "./TrendingUp.vue?vue&type=template&id=e950dd50&"
import script from "./TrendingUp.vue?vue&type=script&lang=js&"
export * from "./TrendingUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports